import React, { useState, useEffect } from 'react';
import axios from '../../../services/axios';
import EditSiteModal from './editsitemodal';

const TableSitesManagement = () => {

    const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
    const [selectedSiteId, setSelectedSiteId] = useState(null);
    const [sitesManagerData, setSitesManagerData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const [currentSite, setCurrentSite] = useState(null);

    useEffect(() => {
        const fetchInitialSitesData = async () => {
            try {
                const response = await axios.get('/api/sites-managerment/');
                setSitesManagerData(response);
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching initial site data:', error);
            }
        };

        fetchInitialSitesData();
    }, []);

    const confirmDelete = (siteId) => {
        setSelectedSiteId(siteId);
        setConfirmModalOpen(true);
    };

    const handleEdit = (site) => {
        setCurrentSite(site);
        setEditModalOpen(true);
    };

    const handleDelete = async (siteId) => {
        try {
            await axios.delete(`/api/sites-managerment/`, { data: { id: siteId } });
            const updatedSitesData = sitesManagerData.filter((site) => site.id !== siteId);
            setSitesManagerData(updatedSitesData);
            setConfirmModalOpen(false);
        } catch (error) {
            console.error('Error deleting site:', error);
        }
    };

    const handleSaveEdit = async (updatedSite) => {
        try {
            await axios.put(`/api/sites-managerment/`, updatedSite);

            // Cập nhật thông tin của site trong danh sách sitesManagerData
            const updatedSitesData = sitesManagerData.map((site) => {
                if (site.id === updatedSite.id) {
                    return updatedSite;
                }
                return site;
            });

            setSitesManagerData(updatedSitesData);
            setEditModalOpen(false);
        } catch (error) {
            console.error('Error updating site:', error);
        }
    };

    if (isLoading) {
        return (
            <div className='bg-white rounded-sm'>
                {/* Hiển thị loading spinner hoặc thông báo loading */}
            </div>
        );
    }

    return (
        <div className='items-center justify-center w-full mb-10 bg-white rounded-sm'>
            <div className='p-1 p-3 text-sm font-semibold border-b border-gray-200'>
                Danh Sách Site
            </div>
            <table className='w-full divide-y divide-gray-200'>
                <thead className='bg-gray-50'>
                    <tr>
                        <th scope='col' className='px-3 py-3 text-xs font-bold tracking-wider text-center text-gray-500 uppercase'>
                            Site Name
                        </th>
                        <th scope='col' className='px-3 py-3 text-xs font-bold tracking-wider text-center text-gray-500 uppercase'>
                            Site Ratio
                        </th>
                        <th scope='col' className='px-3 py-3 text-xs font-bold tracking-wider text-center text-gray-500 uppercase'>
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody className='bg-white divide-y divide-gray-200'>
                    {sitesManagerData.map((site, index) => (
                        <tr key={index}>
                            <td className='py-2 text-sm font-medium text-center text-gray-900 whitespace-nowrap'>
                                {site.site_name}
                            </td>
                            <td className='py-2 text-sm text-center text-gray-500 whitespace-nowrap'>
                                {site.site_ratio}
                            </td>
                            <td className="flex justify-center gap-5 py-2 text-sm text-center text-gray-500 whitespace-nowrap">
                                <button onClick={() => handleEdit(site)} className="mr-3 text-blue-600 hover:text-blue-900">
                                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">

                                        <g>
                                            <title>Layer 1</title>
                                            <path id="svg_1" fill="#6563ff" d="m19,10.0058a1,1 0 0 0 -1,1l0,6a1,1 0 0 1 -1,1l-14,0a1,1 0 0 1 -1,-1l0,-14a1,1 0 0 1 1,-1l6,0a1,1 0 0 0 0,-2l-6,0a3,3 0 0 0 -3,3l0,14a3,3 0 0 0 3,3l14,0a3,3 0 0 0 3,-3l0,-6a1,1 0 0 0 -1,-1zm-15,0.76l0,4.24a1,1 0 0 0 1,1l4.24,0a1,1 0 0 0 0.71,-0.29l6.92,-6.93l0,0l2.84,-2.78a1,1 0 0 0 0,-1.42l-4.24,-4.29a1,1 0 0 0 -1.42,0l-2.82,2.83l0,0l-6.94,6.93a1,1 0 0 0 -0.29,0.71zm10.76,-8.35l2.83,2.83l-1.42,1.42l-2.83,-2.83l1.42,-1.42zm-8.76,8.76l5.93,-5.93l2.83,2.83l-5.93,5.93l-2.83,0l0,-2.83z" />
                                        </g>
                                    </svg>
                                </button>
                                <button onClick={() => confirmDelete(site.id)} className="text-red-600 hover:text-red-900">
                                    <svg width="16" height="18" clip-rule="evenodd" fillRule="evenodd" imageRendering="optimizeQuality" textRendering="geometricPrecision" shapeRendering="geometricPrecision">

                                        <g>
                                            <path stroke="null" id="svg_1" d="m1.69895,4.91684l12.7014,0c0.60912,0 1.04632,0.34316 0.98526,0.98842l-1.07825,11.12632c-0.04316,0.46877 -0.31544,0.92702 -0.88772,0.92702l-10.74105,0c-0.47825,-0.02561 -0.83298,-0.34211 -0.88035,-0.84702l-1.06877,-11.18211c-0.06105,-0.64491 0.34211,-1.01263 0.96947,-1.01263zm-0.83965,-3.57825l4.78842,0l0,-0.35263c0,-0.5593 0.35789,-0.98596 0.94807,-0.98596l2.85193,0c0.60702,0 0.97018,0.41298 0.97018,0.98281l0,0.35579l4.86526,0c0.02,0 0.03895,0.00246 0.05895,0.00456c0.35895,0.03263 0.63684,0.31649 0.65579,0.67439c0.00105,0.02772 0.00211,0.04877 0.00211,0.07614l0,1.50035c0,0.21018 -0.16596,0.38211 -0.37263,0.39263c-0.01895,0 -0.03825,0.00105 -0.05719,0.00105l-15.17649,0c-0.20772,0 -0.37789,-0.1614 -0.39263,-0.36421c0,-0.02526 -0.00105,-0.05158 -0.00105,-0.07825l0,-1.38596c0,-0.38351 0.14772,-0.72667 0.59018,-0.80772c0.08877,-0.01579 0.1786,-0.01298 0.26912,-0.01298zm2.93965,7.31158c-0.01789,-0.35684 0.28807,-0.6607 0.68526,-0.67754c0.39684,-0.01719 0.73474,0.25965 0.75263,0.61649l0.30526,5.63579c0.01789,0.35719 -0.28842,0.66105 -0.68526,0.67789c-0.39719,0.01684 -0.73474,-0.25965 -0.75298,-0.61649l-0.30491,-5.63614zm7.07719,-0.06105c0.01789,-0.35684 0.35579,-0.63368 0.75263,-0.61649c0.39719,0.01684 0.70316,0.3207 0.68526,0.67754l-0.30386,5.63614c-0.01825,0.35684 -0.35579,0.63333 -0.75298,0.61649c-0.39684,-0.01684 -0.70316,-0.3207 -0.68526,-0.67789l0.30421,-5.63579zm-3.61193,0.03053c0,-0.35895 0.32386,-0.65018 0.72211,-0.65018c0.39789,0 0.72211,0.29123 0.72211,0.65018l0,5.63614c0,0.35895 -0.32421,0.65018 -0.72211,0.65018c-0.39825,0 -0.72211,-0.29123 -0.72211,-0.65018l0,-5.63614z" fill="#FD3B3B" />
                                        </g>
                                    </svg>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {isEditModalOpen && (
                <EditSiteModal
                    site={currentSite}
                    onClose={() => setEditModalOpen(false)}
                    onSave={handleSaveEdit}
                />
            )}

            {isConfirmModalOpen && (

                <div className="fixed inset-0 z-10 overflow-y-auto" aria-labelledby="modal title" role="dialog" aria-modal="true">
                    <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                        <div className="fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" aria-hidden="true"></div>

                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                        <div className="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" >
                            <div className="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                                <div className="sm:flex sm:items-start">
                                    <button className="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full sm:mx-0 sm:h-10 sm:w-10" >
                                        <svg className="w-6 h-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                                        </svg>
                                    </button>

                                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                        <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Delete Site</h3>

                                        <div className="mt-2">
                                            <p className="text-sm text-gray-500">
                                                Bạn có chắc chắn muốn xóa site hiện tại hay không?
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
                                <button type="button" className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-red-600 border border-transparent rounded-md shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm" onClick={() => handleDelete(selectedSiteId)}>Delete</button>
                                <button type="button" className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" onClick={() => setConfirmModalOpen(false)}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>

            )}
        </div>
    );
};

export default TableSitesManagement;